<template>
  <!-- 电子竞技榜->电子排行榜 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()">搜索</a-button
          >
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="allExport()">导出全部</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" @click="showUpload">导入数据</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="termDelete()">全部删除</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      size="middle"
      row-key="ID"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="false"
      bordered
    >
      <template slot="title">
        <span></span>
        <a-row :gutter="24">
          <a-col :span="6" style="line-height: 30px">统计列表</a-col>
        </a-row>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination
        style="float: right"
        show-size-changer
        :default-current="pagination.current"
        :total="pagination.total"
        :show-total="(total) => `共 ${total} 条`"
        :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange"
        @showSizeChange="sizeChange"
      />
      最后上传笔数:{{( pagination.uploadcount )}} 笔
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="数据导入"  @ok="modalOK">
      <div class="box" style="height: 150px">
        <a-button
          type="primary"
          :disabled="fileList.length === 0"
          :loading="uploading"
          @click="handleUpload"
          >开始上传</a-button
        >
        <a-upload
          :file-list="fileList"
          :remove="handleRemove"
          :before-upload="beforeUpload"
        >
          <a-button> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload>
       <br>
        <a-button type="primary" @click="dowTemplate"> 下载模板 </a-button>
        
      </div>
    </a-modal>
  </a-layout-content>
</template>
<script>
import XLSX from "xlsx";
import { arrayExport } from "../../js/xlsxTool";

export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: "会员帐号",
          dataIndex: "UserID",
          align: "center",
        },
        {
          title: "有效金额",
          dataIndex: "Validbet",
          align: "center",
        },
        {
          title: "派彩金额",
          dataIndex: "Result",
          align: "center",
        },
        {
          title: "反水金额",
          dataIndex: "Rebate",
          align: "center",
        },
        {
          title: "负盈利",
          dataIndex: "Winlose",
          align: "center",
        },
      ],
      userid: undefined,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        uploadcount: 0,
        sizeList: ["10", "20", "30", "40", "50"],
      },
      loading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      visible: false, //弹框状态
      fileList: [],
      uploading: false,
    };
  },
  methods: {
    // 搜索
    search() {
      this.pagination.current = 1;
      this.qryListAPI();
    },
    //分页页数的改变
    pageNumberChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    //  分页显示条数的变化
    sizeChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    // 导出全部
    allExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出全部数据吗？",
        onOk() {
          that.exportData();
        },
      });
    },
    //导出
    exportData() {
      let today = new Date();
      this.$message.success(
        "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
      );
      this.axios({
        url: "/principal/exportprincipaldata",
        method: "get",
        params: {},
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            "统计数据- " + today.toISOString().split("T")[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
    // 下载模板
    dowTemplate() {
      var aoa = [
        ["会员账号", "有效金额", "派彩金额", "反水金额"],
        ["ccc", "22", "22", "22"],
      ];
      arrayExport(aoa, "上传模板");
    },
    // 全部删除
    termDelete() {
      const that = this;
      this.$confirm({
        title: "全部删除",
        content: "您确定要删除全部数据吗？",
        onOk() {
          that.axios
            .post("/principal/principaldatadelete", {})
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 显示上传弹框
    showUpload() {
      this.visible = true;
    },
    // 确认上传
    modalOK() {
      this.visible = false;
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
        return false;
      }
      this.fileList = [file];
      return false;
    },
    handleUpload() {
      this.uploading = true;
      const that = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "string" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = that.getHeaderRow(worksheet);
          // 改变头部
          worksheet["A1"].w = "UserID";
          worksheet["B1"].w = "Validbet";
          worksheet["C1"].w = "Result";
          worksheet["D1"].w = "Rebate";
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results });
          resolve();
        };
        reader.readAsArrayBuffer(that.fileList[0]);
      });
    },
    generateData({ header, results }) {
      //进行上传
      this.uploading = false;
      this.fileList = [];
      this.axios
        .post("/principal/importprincipaldata", {
          UserList: results,
        })
        .then((res) => {
          if (res.data) {
            this.mymessage(this, "导入成功");
            this.qryListAPI();
          }
        });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        let hdr = "UNKNOWN " + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    // 查询API
    qryListAPI() {
      this.loading = true;
      this.axios
        .post("/principal/getprincipaldataqrylist", {
          SaleUser: this.userid == undefined ? "" : this.userid,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        })
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.pagination.uploadcount = res.uploadcount;
            this.loading = false;
            this.data = res.data;
          }
        });
    },
  },
  //首次加载
  created() {
    this.qryListAPI();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    // const roleID = [194, 195, 196, 197, 198];
    // var isRole = roleID.filter(function (item) {
    //   return array.indexOf(item) != -1;
    // });
    // //功能权限获取
    // isRole.forEach((element) => {
    //   this["role" + element] = true;
    // });
  },
};
</script>

<style>
.red {
  color: rgb(255, 0, 0);
}
.marr10 {
  background-color: green !important;
  border-color: green !important;
}
</style>


// WEBPACK FOOTER //
// src/components/principal/statistics.vue